import { InvoiceItem, Invoice } from 'services/accounts/types';

export type FlatInvoiceItem = Omit<InvoiceItem, 'items'> & { depth: number };

export const prorateInvoiceItems = (invoice: Invoice, ratio: number): Invoice => {
  const refundInvoiceItem = (item: InvoiceItem): InvoiceItem => {
    const amount = -item.amount * ratio;
    const items = item.items?.map(refundInvoiceItem);
    return { ...item, amount, items };
  };

  const items = invoice.items.map(refundInvoiceItem);
  return { ...invoice, items };
};

export const flattenInvoiceItems = (invoice: Invoice, filter?: (item: InvoiceItem) => boolean): FlatInvoiceItem[] => {
  const items: FlatInvoiceItem[] = [];
  const flattenInvoiceItem = (depth: number, item: InvoiceItem) => {
    if (!filter || filter(item)) {
      items.push({ depth, ...item });
      item.items?.forEach(i => (
        flattenInvoiceItem(depth + 1, i)
      ));
    }
  };
  invoice.items.forEach(i => (
    flattenInvoiceItem(0, i)
  ));
  return items;
};

export const totalInvoiceItems = (invoice: Invoice, filter?: (item: InvoiceItem) => boolean): number => {
  const total = { amount: 0.0 };
  const totalInvoiceItem = (item: InvoiceItem) => {
    if (!filter || filter(item)) {
      total.amount += item.amount;
      item.items?.forEach(i => (
        totalInvoiceItem(i)
      ));
    }
  };
  invoice.items.forEach(i => (
    totalInvoiceItem(i)
  ));
  return total.amount;
};

export const hasProrationItems = (invoice: Invoice): boolean => {
  const checkProrationItem = (item: InvoiceItem): boolean => {
    if (item.proration) return true;
    return item.items?.some(i => (
      checkProrationItem(i)
    )) ?? false;
  };
  return invoice.items.some(i => (
    checkProrationItem(i)
  ));
};
